// @vendors
import React from 'react';
import PropTypes from 'prop-types';

// @components
import { OKInput } from 'commonsComponents/OKInput';
import OKSelect from 'components/commons/OKSelect/OKSelect';
import { DateInput } from 'components/commons/dateInput/dateInput';
import { LoadingSection } from 'commonsComponents/loadingSection';

import {
    padLeftWithZeros
} from 'utilities/stringHelper'

const {
    COMPOUND,
    DATE,
    GENERIC,
    PASSWORD
} = require('constants/aggregator/loginFieldTypes');

class AggregatorAddEntityStepLoginForm extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handleOnChangeValue = this.handleOnChangeValue.bind(this)
        this.renderSelect = this.renderSelect.bind(this)
        this.renderInput = this.renderInput.bind(this)
        this.getOptions = this.getOptions.bind(this)
        this.renderByType = this.renderByType.bind(this)
        this.renderParam = this.renderParam.bind(this)
        this.renderPassword = this.renderPassword.bind(this)
        this.renderGeneric = this.renderGeneric.bind(this)
        this.renderDate = this.renderDate.bind(this)
        this.renderCompound = this.renderCompound.bind(this)
    }

    componentDidMount(){
        const { form, setFormValue } = this.props

        const option = form && form.filter(v => v.get('options', {size: 0}).size == 1).getIn([0,'options', 0], null)

        if (option){
            setFormValue(option.getIn(['name']), option.getIn(['value', 0, 'value'], null))
        }
    }

    componentDidUpdate(nextProps){
        const { form, setFormValue } = this.props

        if (form != nextProps.form) {
            const option = form && form.filter(v => v.get('options', {size: 0}).size == 1).getIn([0,'options', 0], null)

            if (option){
                setFormValue(option.getIn(['name']), option.getIn(['value', 0, 'value'], null))
            }
        }
    }

    componentWillUnmount(){
        const { clearFormValues } = this.props

        clearFormValues()
    }

    handleOnChangeValue(id, value) {
        this.props.setFormValue(id, value)
    }

    getOptions(paramsValue){
        if (!paramsValue) return []
        if (Array.isArray(paramsValue)) return paramsValue
        return (paramsValue || []).map(pv => ({value: pv.get('value'), label: pv.get('label')})).toArray()
    }

    renderSelect(param) {
        const { values } = this.props

        return (
            <OKSelect
                label={param.get('description')}
                value={values.get(param.get('name'))}
                id={param.get('name')}
                onChange={opt => this.handleOnChangeValue(param.get('name'), opt.value)}
                options={this.getOptions(param.get('value'))}
            />
        )
    }

    renderInput(param, type = 'text') {
        const { values } = this.props

        return (
            <OKInput
                autoComplete="off"
                label={param.get('description')}
                type={type}
                placeholder={param.get('placeholder')}
                value={values.get(param.get('name'))}
                id={param.get('name')}
                onChange={event => this.handleOnChangeValue(param.get('name'), event.target.value)}
            />
        )
    }

    renderCompound(param){
        return (
            <div className="aggregator-add-entity__wizard__wizard-step-login-form__param__date col-xs-12">
                <div className="row">
                    <div className="aggregator-add-entity__wizard__wizard-step-login-form__param__date__options col-xs-6">
                        {this.renderSelect(param.getIn(['options', 0]))}
                    </div>
                    <div className="aggregator-add-entity__wizard__wizard-step-login-form__param__date__text col-xs-6">
                        {this.renderInput(param)}
                    </div>
                </div>
            </div>
        )
    }

    renderDate(){
        return (
            <div className="aggregator-add-entity__wizard__wizard-step-login-form__param__date col-xs-12">
                <DateInput
                    onDayChange={(text) => this.handleOnChangeValue('birthDay', padLeftWithZeros((text || "").toString(), 2))}
                    onMonthChange={(text) => this.handleOnChangeValue('birthMonth', padLeftWithZeros((text || "").toString(), 2))}
                    onYearChange={(text) => this.handleOnChangeValue('birthYear', padLeftWithZeros((text || "").toString(), 4))}
                />
            </div>
        )
    }

    renderGeneric(param){
        return (
            <div className="aggregator-add-entity__wizard__wizard-step-login-form__param__generic col-xs-12">
                {this.renderInput(param)}
            </div>
        )
    }

    renderPassword(param){
        return (
            <div className="aggregator-add-entity__wizard__wizard-step-login-form__param__password col-xs-12">
                {this.renderInput(param, "password")}
            </div>
        )
    }

    renderByType(param) {
        const type = param.get('type')

        const typesComponents = {
            [COMPOUND]: this.renderCompound,
            [DATE]: this.renderDate,
            [GENERIC]: this.renderGeneric,
            [PASSWORD]: this.renderPassword
        }

        return typesComponents[type](param)
    }

    renderParam(param) {
        return (
            <div key={param.get('name')} className="row aggregator-add-entity__wizard__wizard-step-login-form__param">
                {
                    this.renderByType(param)
                }
            </div>
        )
    }

    shouldShowForm = () => {
        const { form, isFetching } = this.props
        return !isFetching && form ? true : false;
    }
    
    render() {
        const { form } = this.props

        return (
            <div className="aggregator-add-entity__wizard__wizard-step-login-form">
                {this.shouldShowForm() ?
                    <div className="aggregator-add-entity__wizard__wizard-step-login-form__form">
                        <form ref={(ref) => this.form = ref} autoComplete="off">
                            {form.valueSeq().sortBy(v => v.get('order')).map((v) => this.renderParam(v))}
                        </form>
                    </div> :
                    <LoadingSection />
                }
            </div>
        );
    }
}


AggregatorAddEntityStepLoginForm.propTypes = {
    setFormValue: PropTypes.func,
    clearFormValues: PropTypes.func,
    form: PropTypes.object,
    values: PropTypes.object,
    isFetching: PropTypes.bool
}

export { AggregatorAddEntityStepLoginForm };
